import styled from 'styled-components';

export const StyledVisitForm = styled.form`
   width: 100%;
   height: 100%;
   padding-top: 4px;
`;

StyledVisitForm.displayName = 'StyledVisitForm';
